module.exports = __webpack_public_path__ + "static/media/Logo.94808c2a.png";